import { TENANT_EDITION } from '@/brand/edition';

// There is one edition and no licensing endpoint to ask; see brand/edition.ts.
export const useGetTenantLicense = (): {
	isCloudUser: boolean;
	isEnterpriseSelfHostedUser: boolean;
	isCommunityUser: boolean;
	isCommunityEnterpriseUser: boolean;
} => ({ ...TENANT_EDITION });
